import axiosNest from '../../api/axiosNest';

/**
 * Weryfikacja przewoźnika (24.10.2026, S-24.10-11) — wywołania API
 * (`apps/api/src/carriers/carriers.controller.ts`, trasy `…/verification`).
 * Wartości `item`, `state` i `status` to dane API, nie tłumaczymy.
 */

/** Klucz przełącznika — jak w rejestrze API. */
export const FEATURE_CARRIER_VERIFICATION = 'carrierVerification';

export type VerificationItem = 'ocp' | 'license' | 'vat';

export interface VerificationItemView {
  item: VerificationItem;
  label: string;
  state: 'confirmed' | 'missing' | 'expired' | 'notEntered';
  stateLabel: string;
  present: boolean | null;
  number: string | null;
  validUntil: string | null;
  checkedOn: string | null;
  setBy: string | null;
  setAt: string | null;
}

export interface CarrierVerification {
  status: 'full' | 'partial' | 'unknown';
  statusLabel: string;
  items: VerificationItemView[];
  gaps: string[];
}

export interface VerificationInput {
  present: boolean;
  number?: string | null;
  /** `RRRR-MM-DD`. */
  validUntil?: string | null;
  /** `RRRR-MM-DD`. */
  checkedOn?: string | null;
}

export async function fetchCarrierVerification(id: number | string): Promise<CarrierVerification> {
  const { data } = await axiosNest.get<CarrierVerification>(`/carriers/${id}/verification`);
  return data;
}

export async function saveCarrierVerification(
  id: number | string,
  item: VerificationItem,
  input: VerificationInput,
): Promise<CarrierVerification> {
  const { data } = await axiosNest.put<CarrierVerification>(`/carriers/${id}/verification/${item}`, input);
  return data;
}
